import React, { FunctionComponent } from 'react';
import { DataCategory, CompanyProfileDetail, DataValueCompanyPageAbout } from '../../../types/companyDetail';

type Props = {
  details: CompanyProfileDetail;
  dataCategory: DataCategory;
  dataValue: DataValueCompanyPageAbout;
};

export const Presentation: FunctionComponent<Props> = ({
  details,
  dataCategory,
  dataValue,
}) => {
  return (
    <section className="company__page__recruitments maskno">
      <div className="company__page__recruitments__header">
        <h2 className="company__page__recruitments__header--title">
          会社情報
        </h2>
      </div>

      <div className="company__page__about">
        <table className="company__page__about__info">
          <tbody>
            <tr>
              <td>会社・団体名</td>
              <td>{details.name}</td>
            </tr>
            <tr>
              <td>資本金</td>
              <td>{details.shihonkin}</td>
            </tr>
            <tr>
              <td>設立年月</td>
              <td>{details.setsuritsunengetsu}</td>
            </tr>
            <tr>
              <td>代表者氏名</td>
              <td>{details.daihyoshaname}</td>
            </tr>
            <tr>
              <td>従業員数</td>
              <td>{details.jugyoinsu}</td>
            </tr>
            <tr>
              <td>本社所在地</td>
              <td>{details.honshashozaichi}</td>
            </tr>
            <tr>
              <td>業種</td>
              <td className='gtm-company_info-view-count' data-event-name='company_info on screen' data-category={dataCategory} data-value={dataValue.industryLink}>
                {details.industries?.map((industry, idx) => {
                  const isLast = idx === details.industries.length - 1;
                  return (
                    <React.Fragment key={industry.enName}>
                      <a
                        href={`/companies/tag/${industry.enName}`}
                        className="link"
                        data-event="click"
                        data-category={dataCategory}
                        data-value={dataValue.industryLink}
                      >
                        {industry.jpName}
                      </a>
                      {/* 元コードのクラス付与ロジックを踏襲（最後に devide クラスを付与） */}
                      <strong className={isLast ? 'devide' : ''}>&nbsp;/&nbsp;</strong>
                    </React.Fragment>
                  );
                })}
              </td>
            </tr>
            <tr>
              <td>ホームページ</td>
              <td>
                <a
                  href={details.url}
                  className="link gtm-company_info-view-count"
                  target="_blank"
                  rel="noreferrer"
                  data-event-name='company_info on screen'
                  data-event="click"
                  data-category={dataCategory}
                  data-value={dataValue.companyLink}
                >
                  {details.url}
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        {details.honshashozaichi !== '' && (
          <div className="company__page__about__map">
            <iframe
              style={{ border: 0 }}
              src={`https://www.google.com/maps/embed/v1/search?key=AIzaSyDKeZzaRmCjZ9ZYFPoN0wbRTJ4W3dj1gfA&q=${details.honshashozaichi}`}
              allowFullScreen
            />
          </div>
        )}
      </div>
    </section>
  );
};
